import { baseButtonRuleSets } from './buttonRuleSets';

const baseVariables = {
  appLayout: {
    stripColors: {
      stripColor1: '#7dae20',
      stripColor2: '#f8b102',
      stripColor3: '#305769',
      stripColor4: '#008600',
      stripColor5: '#d1d800',
      stripColor6: '#201c17',
    },
    width: '1600px',
  },
  borders: {
    radius: '0.1875rem',
    width: {
      base: '0.0625rem',
      bigger: '0.125rem',
    },
  },
  breakpoints: {
    lg: 992,
    md: 768,
    xlg: 1356,
  },
  button: {
    horizontalPadding: '1.0625rem',
  },
  colors: {
    black: '#201c17',
    blue: '#046eb1',
    cardinal: '#CA1F40',
    darkGrey: '#525455',
    darkRed: '#972114',
    green: '#008600',
    lightGreen: '#b8e986',
    lightGrey: '#fafafa',
    logoBlue: '#0077bd',
    logoDarkRed: '#cc0b18',
    logoGreen: '#18a035',
    logoOrange: '#f39100',
    midGrey: '#959595',
    midRed: '#b81c0a',
    platinum: '#e4e4e4',
    red: '#da1600',
    silver: '#f3f3f3',
    white: '#fff',
    yellow: '#efd063',
  },
  customBreakpoints: {
    vlg: 1296,
  },
  customColors: {
    azure: '#2F6DAC',
    leadingColor: {
      base: '#da1600',
      dark: '#972114',
      mid: '#b81c0a',
    },
    lightBlue: '#53a9d3',
    lightNavy: '#0088ca',
    statusGrey: '#6e6c6e',
  },
  fonts: {
    size: {
      base: '1rem',
      bigger0: '1.125rem',
      bigger1: '1.25rem',
      bigger2: '1.625rem',
      bigger3: '2rem',
      bigger4: '2.1875rem',
      bigger5: '21.5625rem',
      bigger6: '3.75rem',
      root: '16px',
      smaller0: '0.875rem',
      smaller1: '0.75rem',
      smaller2: '0.675rem',
      smaller3: '0.5625rem',
    },
    weight: {
      bold: 700,
      extraBold: 800,
      extraLight: 200,
      heavy: 900,
      light: 300,
      medium: 500,
      regular: 400,
      semiBold: 600,
      thin: 100,
    },
  },
  icons: {
    size: {
      extraLarge: '2rem',
      extraLargePlus: '2.25rem',
      large: '1.5rem',
      medium: '1rem',
      semiLarge: '1.75rem',
      small: '0.75rem',
    },
    svg: {} as Record<string, string>,
  },
  list: {
    row: {
      height: {
        base: '2.5rem',
        bigger: '3.5rem',
      },
    },
  },
  shadows: {
    lightShadow: '0px 1px 2px rgba(0, 0, 0, 0.22), 0px 0px 1px rgba(0, 0, 0, 0.32)',
    shadow: '0 1px 16px 0 rgba(0, 0, 0, 0.22), 0 0 1px 0 rgba(0, 0, 0, 0.32)',
  },
  typography: {
    primaryFont: '"Montserrat", sans-serif',
    secondaryFont: '"mBank", sans-serif',
  },
  zIndex: {
    zIndexBackdrop: 100,
    zIndexDatePicker: 201,
    zIndexHeaderLogo: 201,
    zIndexMenuMore: 210,
    zIndexModal: 200,
    zIndexModalContainer: 120,
    zIndexProcess: 201,
    zIndexProfileSelector: 200,
    zIndexProfileSelectorOverlay: 120,
    zIndexStripe: 201,
    zIndexToast: 210,
  },
};

export const BaseTheme = {
  breakpoints: [768, 992, 1356],
  gridGap: 1.5,
  gridSize: 12,
  mode: 'INDIVIDUAL',
  ruleSets: {
    button: baseButtonRuleSets,
  },
  space: ['0', '1rem', '1.5rem', '3rem', '4.5rem', '6rem', '7.5rem'],
  variables: baseVariables,
};
